import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { OrderedList } from '@components/common/OrderedList'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { SECTION_NAMES } from '@constants/sectionNames'
import { Banner, ButtonClean, HeadContent, Skeleton } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { ConnectBar } from '../../components/ConnectBar/ConnectBar'
import { YouTubeVideoEntry } from '../../components/YouTubeVideoEntry/YouTubeVideoEntry'
import { useInstagramFeed } from './hooks/useInstagramFeed'

export const AppsInstagramFeed = () => {
  const { instagram } = useInstagramFeed()

  return (
    <>
      <HeadContent title={SECTION_NAMES.appInstagram} />
      <PageLayout size="tiny">
        <Dashboard.Section
          name={SECTION_NAMES.appInstagram}
          topContent={<DashboardBackButton label={SECTION_NAMES.apps} to={routing.apps.self} />}
          bottomContent={
            <div style={{ lineHeight: 1.5 }}>
              <p style={{ marginBottom: 16 }}>
                <Banner appearance="warning">
                  To use this feature, your Instagram account must be set to Business or Creator
                  type.{' '}
                  <ButtonClean
                    appearance="secondary"
                    label="Learn how to switch your account"
                    href={routing.external.instagram.accountSwitchDoc}
                    target="_blank"
                  />
                  .
                </Banner>
              </p>
              <p>Showcase your Instagram feed on your homepage.</p>
              <OrderedList>
                <OrderedList.Item>Connect your Instagram account.</OrderedList.Item>
                <OrderedList.Item>
                  Add “Instagram feed” section to your homepage on {SECTION_NAMES.themeEditor} tab.
                </OrderedList.Item>
              </OrderedList>
            </div>
          }
        >
          <div style={{ marginTop: 16 - 24, marginBottom: 40 }}>
            {instagram.status && (
              <div style={{ marginBlock: 20 }}>
                <YouTubeVideoEntry
                  title="Showcase Your Instagram Feed on Your Shop"
                  description="Add your Instagram feed directly to your Fourthwall shop and keep your followers engaged with your latest content."
                  size={instagram.status === 'NOT_CONNECTED' ? 'regular' : 'compact'}
                  videoId="oCYOQ3Wpw1w"
                />
              </div>
            )}
            {instagram.connectBar ? (
              <ConnectBar {...instagram.connectBar} />
            ) : (
              <Skeleton>
                <Skeleton.Shape height={64} />
              </Skeleton>
            )}
          </div>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
